import React from 'react';
import realcarMencoes from '../Components/Mencao/realcarMencoes';

function formatarData(dataHora) {
    const d = new Date(dataHora);
    return d.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    });
}

function ChamadoTimeline({ eventos, onDelete }) {
    return (
        <div className="chamado-timeline">
            <h3 className="chamado-timeline-titulo">Histórico do chamado</h3>
            <div className="chamado-timeline-list">
                {(eventos || []).map((ev, idx) => (
                    <div
                        key={ev.codHis ?? ev.id ?? idx}
                        className={`chamado-timeline-item ${ev.interno ? 'chamado-timeline-item-interno' : ''}`}
                    >
                        <div className="chamado-timeline-item-header">
                            <span className="chamado-timeline-autor">{ev.autor_nome || '—'}</span>
                            <span className="chamado-timeline-data">{formatarData(ev.data)}</span>
                            {onDelete && (
                                <button
                                    type="button"
                                    className="chamado-timeline-delete"
                                    onClick={() => onDelete(ev.codHis)}
                                    title="Excluir"
                                    aria-label="Excluir"
                                >
                                    <i className="fas fa-trash" aria-hidden="true" />
                                </button>
                            )}
                        </div>
                        {ev.interno && <span className="chamado-timeline-badge-interno">Comentário interno</span>}
                        <div className="chamado-timeline-mensagem">{realcarMencoes(ev.descricao)}</div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default ChamadoTimeline;
